import React from 'react'
import { makeStyles } from 'tss-react/mui'

import { Theme, Typography } from '@mui/material'

import { ScoutingCampaignListViewActions } from './ScoutingCampaignListViewActions.component'
import { ScoutingCampaignListViewContent } from './ScoutingCampaignListViewContent.component'
import { ScoutingCampaignListViewProvider } from './ScoutingCampaignListViewStore'

export function ScoutingCampaignListView() {
  const { classes } = useStyles()
  return (
    <ScoutingCampaignListViewProvider>
      <div className={classes.headerContainer}>
        <Typography className={classes.headline}>Spaces</Typography>
        <ScoutingCampaignListViewActions className={classes.headerActions} />
      </div>
      <ScoutingCampaignListViewContent className={classes.content} />
    </ScoutingCampaignListViewProvider>
  )
}

const useStyles = makeStyles()(({ spacing, typography, breakpoints }: Theme) => ({
  headerContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: spacing(2),
  },
  headerActions: {
    display: 'flex',
  },
  content: {
    position: 'relative',
    minHeight: spacing(50),
  },
  headline: {
    display: 'inline-block',
    fontSize: typography.h5.fontSize,
    [breakpoints.down('sm')]: {
      fontSize: typography.subtitle1.fontSize,
    },
  },
}))
